import React, { useState, useEffect } from "react";
import { LinearProgress } from "@mui/material";
import Logo from "../images/logo/ezcarrentals-Newlogo.png";

function LoadingProgress() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1113000);

    window.addEventListener("load", () => {
      setLoading(false);
    });

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className='loading-progress'>
      <img src={Logo} alt='EZ Car Rentals Logo' />
      {loading ? (
        <LinearProgress color='secondary' variant='indeterminate' />
      ) : null}
    </div>
  );
}

export default LoadingProgress;
